import useMaskedCardNumber from "@/hooks/useMaskedCardNumber";
import useThousandsSeparator from "@/hooks/useThousandsSeparator";
import BoxKit from "@/shared/components/kit/box";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { Divider } from "@mui/material";
/**
 * ContentModal
 *
 * نمایش اطلاعات جزئیات تراکنش در یک مودال.
 *
 * ویژگی‌ها:
 * - نمایش مبلغ تراکنش با فرمت عددی فارسی
 * - نمایش نام و نام خانوادگی گیرنده تراکنش
 * - نمایش توضیحات تراکنش
 * - استفاده از Divider خط‌چین برای جداسازی اطلاعات
 *
 * @param detailStepOne داده‌های جزئیات تراکنش
 * @returns JSX.Element
 */
// Task Response: کد عملکردی است، ولی چند نکته بهبود دارد:
// 1. فراخوانی hook‌ها اشتباه است، باید به صورت تابعی استفاده شوند:
//    const formattedValue = useThousandsSeparator();
//    const masked = useMaskedCardNumber();
// 2. marginBottom بسیار زیاد است (103px) که ممکن است طراحی را خراب کند.
// 3. بخش BoxKit و StackKit برای هر فیلد تکراری است، می‌توان آن را به یک کامپوننت کوچک‌تر کاهش داد.
// 4. علامت "\" اضافی بعد از اولین TypoGraphyKit حذف شود.
// 5. اگر مقدار detailStepOne?.data?.data?.name یا last_name undefined باشد، بهتر است fallback داشته باشید.

const ContentModal = ({ detailStepOne }: { detailStepOne: any }) => {
  const formattedValue = useThousandsSeparator;
  const masked = useMaskedCardNumber;

  return (
    <StackKit direction={"column"} sx={{ width: "100%" }}>
      <BoxKit position="relative" sx={{ width: "100%", height: "24px", my: 2, marginBottom: "20px" }}>
        <Divider sx={{position: "absolute",width: "60%",top: "50%",left: "50%",transform: "translate(-50%, -50%)",borderStyle: "dashed",}}/>
        <StackKit direction="row" justifyContent="space-between" sx={{position: "relative",height: "100%",width: "100%",zIndex: 1,marginBottom: "103px",}}>
          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center",}}>
            مبلغ تراکنش
          </TypoGraphyKit>
          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center",}}>
            {formattedValue(detailStepOne?.data?.amount)} ریال
          </TypoGraphyKit>
        </StackKit>
      </BoxKit>    
      <BoxKit position="relative" sx={{ width: "100%", height: "24px", my: 2, marginBottom: "20px" }}>
        <Divider sx={{position: "absolute",width: "60%",top: "50%",left: "50%",transform: "translate(-50%, -50%)",borderStyle: "dashed",}}/>
        <StackKit direction="row" justifyContent="space-between" sx={{position: "relative",height: "100%",width: "100%",zIndex: 1,marginBottom: "103px",}}>
          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center",}}>
            نام و نام خانوادگی{" "}
          </TypoGraphyKit>

          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center",}}>
            {`${detailStepOne?.data?.data?.name || detailStepOne.data.recCard.user.name} ${detailStepOne?.data?.data?.last_name || detailStepOne.data.recCard.user.last_name}`}
          </TypoGraphyKit>
        </StackKit>
      </BoxKit>
      <BoxKit position="relative" sx={{ width: "100%", height: "24px", my: 2, marginBottom: "20px" }}>
        <Divider sx={{position: "absolute",width: "60%",top: "50%",left: "50%",transform: "translate(-50%, -50%)",borderStyle: "dashed",}}/>

        <StackKit direction="row" justifyContent="space-between" sx={{ position: "relative", height: "100%", width: "100%", zIndex: 1, marginBottom: "103px",}}>
          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center", }}>
            توضیحات{" "}
          </TypoGraphyKit>

          <TypoGraphyKit variant="body1" sx={{bgcolor: "background.paper",px: 1,display: "flex",alignItems: "center",}}>
            {detailStepOne?.data?.payFor}
          </TypoGraphyKit>
        </StackKit>
      </BoxKit>
    </StackKit>
  );
};

export default ContentModal;
